/**
 * Created by tomers on 12/24/2014.
 *
 *************************************************************************************************
 **************************************** LIST INITIALIZE ****************************************
 *************************************************************************************************
 var list = new List({
        el: $(), // the list container
        floating: true, // if the list has css class to look like floating. default true.
        groupCollapsible: false, // if the groups in the list are collapsible. default false (might not work. only infrastructure was implemented)
        maxShownItems: 10, // max shown items before the list gets scroll. 0 for un-limit.  default is 10
        itemHeight: 32, // in px, used by the max-height of the list. default is 33
        itemsComparator: function(item) { return item.id } , // comparator function or false for no sorting. default is by value (lower cased)
        groupsOrder: [], // array of the groups order
        enabled: true, // if the component is enabled or disabled. true/false. default is true
        hasCheckbox: true, // if each item has checkbox. true/false. default is true
        selectable: true, // if items in the list can be selected and clickable. default is true
        singleSelectPerGroup: false, // if the list is with groups allow only a single selected item per group
        noItems: {
            value: "NO ITEMS TEXT", // for example: "There are no items"
            enabled: true, // id the 'no items' is clickable. default is false
            visible: true, // if the 'no items' appears. default is false
            tooltip: "no items tooltip"
        },
        newItem: {
            value: "NEW ITEM TEXT", // for example: "Create item " (the filtered value is coming just after this text)
            enabled: true, // id the 'new item' is clickable. default is false
            visible: true, // if the 'new item' appears. default is false
            tooltip: "new item tooltip"
        },
        defaultActions: {
            add: false, // if the list item has 'add' action icon - here should come the tooltip. default false
            select: false, // if the list item has 'select' action icon - here should come the tooltip. default false
            remove: false // if the list item has 'remove' action icon - here should come the tooltip. default false
        },
        items: [
            {
                id: 1,
                value: "Item 1",
                subText: "item description", // optional - will appear in () after the value
                className: "item-class-name",
                tooltip: "Tooltip 1",
                enabled: true,
                selected: true,
                actions: {
                    add: "tooltip text",
                    select: "tooltip text",
                    remove: "tooltip text"
                }
            }
        ],
        selectedItems: [1] // array of the selected items ids - optional
 });
 *************************************************************************************************
 *************************************************************************************************
 *************************************************************************************************
 *
 *
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");
    var _ = require("underscore");
    var $ = require("jquery");

    //Template
    var template = require("ui/list/templates/list.tmpl");

    //List MVC
    var ListModel = require("ui/list/js/models/ListModel");
    var ListGroupView = require("ui/list/js/views/ListGroupView");
    //</editor-fold>

    var EMPTY_CLASS_NAME = "empty";
    var FLOATING_CLASS_NAME = "floating";
    var HAS_VISIBLE_GROUPS_CLASS_NAME = "visible-group-titles";
    var NO_VISIBLE_GROUPS_CLASS_NAME = "no-visible-group-titles";
    var MAX_HEIGHT_BUFFER = 11; // paddings + borders

    var TRIGGERING = {
        CLICK: "click",
        ACTION_ADD: "actionAdd",
        ACTION_SELECT: "actionSelect",
        ACTION_REMOVE: "actionRemove"
    };

    var THEME = {
        DEFAULT: "default-theme",
        NIGHT: "night-theme",
        NO: "no-theme"
    };

    var List = Marionette.CompositeView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        className: "list-component-container",
        template: template,
        itemView: ListGroupView,
        itemViewContainer: "ul.ul-list-container",
        ui: {
            listContainer: "ul.ul-list-container"
        },
        withUIComponents:true,
        events: {},
        itemEventsOld: {
            "itemview:mouseenter": "_onItemMouseEnter",
            "itemview:mouseleave": "_onItemMouseLeave",
            "itemview:click": "_onItemClick",
            "itemview:action-add-click": "_onItemActionAddClick",
            "itemview:action-select-click": "_onItemActionSelectClick",
            "itemview:action-remove-click": "_onItemActionRemoveClick"
        },
        handleMoveInProgressCounter: 0, // count the current moves by keyboard. the mouse events relevant only if 0
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function(options) {
            this._initialize(options);
        },
        itemViewOptions: function(model) {
            return this._itemViewOptions(model);
        },
        onRender: function() {
            this._onRender();
        },
        onClose: function() {
            this._onClose();
        },
        //</editor-fold>

        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        addItem: function(item) {
            this._addItem(item);
        },

        removeItem: function(itemId) {
            this._removeItem(itemId);
        },

        select: function(itemId) {
            this._select(itemId);
        },

        unselect: function(itemId) {
            this._unselect(itemId);
        },

        unselectAll: function() {
            this._unselectAll();
        },

        filter: function(filterValue, page) {
            this._filter(filterValue, page);
        },

        setItems: function(items, options) {
            this._setItems(items, options);
        },

        getItems: function() {
            return this._getItems();
        },

        getAllItems: function() {
            return this._getAllItems();
        },

        getSelectedItems: function() {
            return this._getSelectedItems();
        },

        setItemHeight: function(itemHeight) {
            this._setItemHeight(itemHeight);
        },

        setMaxShownItems: function(maxShownItems) {
            this._setMaxShownItems(maxShownItems);
        },

        setPage: function(page) {
            this._setPage(page);
        },

        getActiveItem: function() {
            return this._getActiveItem();
        },

        hasActiveItem: function() {
            return this._hasActiveItem();
        },

        clearActiveItem: function() {
            this._clearActiveItem();
        },

        moveSelection: function(options) {
            this._moveSelection(options);
        },

        scrollTop: function(options) {
            this._scrollTop(options);
        },

        setError: function(isError, msg) {
            this._setError(isError, msg);
        },

        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("List");
            this.logger.info("Initializing List", "List:_initialize", {options:options});
            this.model = _initListModel(options);

            this.theme = _.has(options, "theme") ? options.theme : THEME.DEFAULT;
            this.container = options.container;
            this.collection = this.model.getFilteredGroupedItems();

            Marionette.bindEntityEvents(this, this, this.itemEventsOld);
        },

        _itemViewOptions: function(model) {
            return {
                model: model,
                hasCheckbox: this.model.hasCheckbox(),
                isNightTheme: this.theme === THEME.NIGHT
            };
        },

        _onRender: function () {
            this.logger.info("Rendering List", "List:_onRender");

            if (this.container) {
                this.container.append(this.$el);
            }
            this._updateListMaxHeight();
            this._updateVisibleGroups();
            this._updateListEmptyClass();
            this.ui.listContainer.addClass(this.theme);
            this.ui.listContainer.toggleClass(FLOATING_CLASS_NAME, this.model.isFloating());

            this._bindEventsToModel();
            this._bindEventsToCollection();
            this._bindEventsToDom();
        },

        _bindEventsToModel: function() {
            this.listenTo(this.model, "change:itemHeight", this._updateListMaxHeight);
            this.listenTo(this.model, "change:maxShownItems", this._updateListMaxHeight);
            this.listenTo(this.model, "change:hasVisibleGroups", this._updateVisibleGroups);
        },

        _bindEventsToCollection: function() {
            this.listenTo(this.collection, "add", this._updateListEmptyClass);
            this.listenTo(this.collection, "remove", this._updateListEmptyClass);
            this.listenTo(this.collection, "reset", this._updateListEmptyClass);
        },

        _bindEventsToDom: function() {
            var boundOnScrollCallback = _.bind(this._onListScroll, this);
            this.ui.listContainer.on("scroll", _.throttle(boundOnScrollCallback, 200));
        },

        _updateListEmptyClass: function() {
            this.ui.listContainer.toggleClass(EMPTY_CLASS_NAME ,this.collection.size() === 0);
        },

        _updateVisibleGroups: function() {
            var hasVisibleGroups = this.model.hasVisibleGroups();
            this.logger.debug("update visible groups", "List:_updateVisibleGroups", {hasVisibleGroups:hasVisibleGroups});
            this.ui.listContainer.toggleClass(HAS_VISIBLE_GROUPS_CLASS_NAME, hasVisibleGroups);
            this.ui.listContainer.toggleClass(NO_VISIBLE_GROUPS_CLASS_NAME, !hasVisibleGroups);
        },

        _updateListMaxHeight: function() {
            if (!this.model.getMaxShownItems()) {
                this.logger.debug("update list max height to auto", "List:_updateListMaxHeight");
                this.ui.listContainer.css("max-height", "auto");
            }
            else {
                var maxHeight = this.model.getItemHeight() * this.model.getMaxShownItems() + MAX_HEIGHT_BUFFER;
                this.logger.debug("update list max height to " + maxHeight, "List:_updateListMaxHeight");
                this.ui.listContainer.css("max-height", maxHeight+"px");
            }
        },

        _onItemActionAddClick: function(groupView, itemView) {
            this.logger.info("list - action clicked - add", "List:_onItemActionAddClick", {itemView:itemView});

            var clickedItemModel = itemView.model;
            this.trigger(TRIGGERING.ACTION_ADD, clickedItemModel.toJSON());
        },

        _onItemActionSelectClick: function(groupView, itemView) {
            this.logger.info("list - action clicked - select", "List:_onItemActionSelectClick", {itemView:itemView});

            var clickedItemModel = itemView.model;
            this.trigger(TRIGGERING.ACTION_SELECT, clickedItemModel.toJSON());
        },

        _onItemActionRemoveClick: function(groupView, itemView) {
            this.logger.info("list - action clicked - remove", "List:_onItemActionRemoveClick", {itemView:itemView});

            var clickedItemModel = itemView.model;
            this.trigger(TRIGGERING.ACTION_REMOVE, clickedItemModel.toJSON());
        },

        _onItemMouseEnter: function(groupView, itemView) {
            if (this.handleMoveInProgressCounter > 0) {
                return;
            }
            var itemModel = itemView.model;
            var itemId = itemModel.id;
            this._setActiveItem(itemId);
        },

        _onItemMouseLeave: function(groupView, itemView) {
            if (this.handleMoveInProgressCounter > 0) {
                return;
            }
            this._clearActiveItem();
        },

        _onItemClick: function(groupView, itemView) {
            this.logger.info("list - item was clicked", "List:_onItemClick", {itemView:itemView});

            var clickedItemModel = itemView.model;
            var clickedItemId = clickedItemModel.id;
            var clicked = this._getItemModel(clickedItemId);

            this._toggleSelection(clickedItemId);
            this._setError(false);
            this.trigger(TRIGGERING.CLICK, clicked.toJSON());
        },

        _onListScroll: function() {
            if (this.model.isPageable() && this.model.isMoreToLoad()) {
                var totalHeight = this.ui.listContainer.prop("scrollHeight");
                var currentScrollTop = this.ui.listContainer.scrollTop();
                var currentHeight = this.ui.listContainer.height();
                var bottomLine = currentScrollTop + currentHeight;

                var offsetToLoadMore = this.model.getLoadMoreOffset();

                if (totalHeight - bottomLine <= offsetToLoadMore) {
                    var currentPage = this.model.getPage();
                    this.model.setPage(currentPage + 1);
                    this.model.filter();
                }
            }

        },

        _scrollTop: function(options) {
            this.logger.debug("list scroll top", "List:_scrollTop");

            this.ui.listContainer.scrollTop(options);
        },

        _moveSelection: function(options) {
            this.logger.info("move active item", "List:_moveSelection", {options:options});

            if (this.model.getItems().length > 0) {
                this.handleMoveInProgressCounter++;
                var futureActiveItemId = this._getFutureActiveItemId(options);
                if (!_.isUndefined(futureActiveItemId) && !_.isNull(futureActiveItemId)) {
                    this.logger.debug("future active item", "List:_moveSelection", {futureActiveItemId:futureActiveItemId});
                    this._setActiveItem(futureActiveItemId);
                    this._scrollToElement({id: futureActiveItemId, isUp:options.isUp});

                    _.delay(_.bind(function() {
                        this.handleMoveInProgressCounter--;
                    }, this), 200);
                }
            }
        },

        _getFutureActiveItemId: function(options) {
            this.logger.debug("find the future active item", "List:_getFutureActiveItemId", {options:options});

            var markerIndex;
            var futureActiveItemIndex;
            var futureActiveItemId;
            var active;
            var minIndex = 0;
            var maxIndex = this.model.getItems().length - 1;
            var complete = false;

            while (!complete && futureActiveItemIndex !== minIndex && futureActiveItemIndex !== maxIndex) {
                if (_.isUndefined(markerIndex)) {
                    if (this.model.hasActiveItem()) {
                        active = this._getListItemById(this.model.getActiveItem());

                        if (active) {
                            markerIndex = active.index;
                        }
                    }
                }

                if (!_.isUndefined(markerIndex)) {
                    futureActiveItemIndex = (options.isUp) ? _.max([markerIndex - 1, minIndex]) : _.min([markerIndex + 1, maxIndex]);
                }
                else {
                    futureActiveItemIndex = minIndex;
                }

                futureActiveItemId = this._getListItemIdByDomIndex(futureActiveItemIndex);

                if (!_.isUndefined(futureActiveItemId) && !_.isNull(futureActiveItemId)) {
                    active = this._getItemModel(futureActiveItemId);
                }

                if (active && active.isEnabled()) {
                    complete = true;
                    break;
                }
                else {
                    futureActiveItemId = void 0;

                    if (markerIndex === futureActiveItemIndex) {
                        complete = true;
                        break;
                    }
                    else {
                        markerIndex = futureActiveItemIndex;
                    }
                }
            }

            this.logger.debug("future active item index", "List:_getFutureActiveItemId", {futureActiveItemIndex:futureActiveItemIndex});
            return futureActiveItemId;
        },

        _getListItemById: function(itemId) {
            this.logger.debug("find list item element by list item id", "List:_getListItemById", {itemId:itemId});

            var listItemElement;
            var listItemsElements = this.ui.listContainer.find("." + ListGroupView.ListItemView.LIST_ITEM_CLASS_NAME);
            listItemsElements.each(function(index) {
                if ($(this).data(ListGroupView.ListItemView.DATA_ID_ATTRIBUTE) === itemId) {
                    listItemElement = {
                        "$el" : $(this),
                        "index": index
                    };
                    return false;
                }
            });

            this.logger.debug("find list item element by list item id", "List:_getListItemById", {listItemElement:listItemElement});
            return listItemElement;
        },

        _getListItemIdByDomIndex: function(itemIndex) {
            this.logger.debug("find list item id by list element dom index", "List:_getListItemIdByDomIndex", {itemIndex:itemIndex});

            var listItemId = ListModel.EMPTY_ACTIVE_ITEM;
            var listItemElement = this.ui.listContainer.find("." + ListGroupView.ListItemView.LIST_ITEM_CLASS_NAME)[itemIndex];
            if (!_.isEmpty(listItemElement)) {
                listItemId = $(listItemElement).data(ListGroupView.ListItemView.DATA_ID_ATTRIBUTE);
            }

            this.logger.debug("find list item id by list element dom index", "List:_getListItemIdByDomIndex", {listItemId:listItemId});
            return listItemId;
        },

        _scrollToElement: function(options) {
            this.logger.debug("scroll to specific element", "List:_scrollToElement", {options:options});
            if (this.model.hasActiveItem()) {
                var activeItemId = options.id;
                var activeItemElement = this._getListItemById(activeItemId).$el;
                var listElement = this.ui.listContainer;
                var itemHeight = activeItemElement.outerHeight();  //item view height
                var listHeight = listElement.height();  // visible list height
                var SCROLL_PADDING = 4;

                var keepScrolling = true;
                while (keepScrolling) {
                    var itemPosition = activeItemElement.position().top; // item top position from visible list top
                    var listTopPosition = listElement.scrollTop(); // position from unvisible list top
                    // if isDirectionUp is undefined then show item on center.
                    if (_.isUndefined(options.isUp)) {
                        //Todo: implement jump to item
                    } else {
                        if (options.isUp) {
                            if (itemHeight >= itemPosition) {
                                listElement.scrollTop(listTopPosition - itemHeight + itemPosition - SCROLL_PADDING);
                                if (listElement.scrollTop() !== (listTopPosition - itemHeight + itemPosition - SCROLL_PADDING)) {
                                    // got to the end, stop tring to scroll
                                    keepScrolling = false;
                                }
                            } else {
                                keepScrolling = false;
                            }
                        } else { // direction is down
                            var itemModuloDown = (listTopPosition + listHeight - SCROLL_PADDING) % itemHeight;
                            if ((listHeight - itemHeight) < (itemPosition + itemHeight)) {
                                listElement.scrollTop(listTopPosition + itemHeight - itemModuloDown);
                                if (listElement.scrollTop() !== (listTopPosition + itemHeight - itemModuloDown)) {
                                    // got to the end, stop tring to scroll
                                    keepScrolling = false;
                                }
                            } else {
                                keepScrolling = false;
                            }
                        }
                    }
                }
            }
        },

        _setError: function(isError, msg) {
            this.children.each(function(itemView) {
                itemView.setError(isError, msg);
            });
        },

        _getActiveItem: function() {
            return this.model.getActiveItem();
        },

        _hasActiveItem: function() {
            return this.model.hasActiveItem();
        },

        _clearActiveItem: function() {
            this._setActiveItem(ListModel.EMPTY_ACTIVE_ITEM);
        },

        _setActiveItem: function(itemId) {
            this.model.setActiveItem(itemId);
        },

        _setItemHeight: function(itemHeight) {
            this.model.setItemHeight(itemHeight);
        },

        _setMaxShownItems: function(maxShownItems) {
            this.model.setMaxShownItems(maxShownItems);
        },

        _setPage: function(page) {
            this.model.setPage(page);
        },

        _toggleSelection: function(itemId) {
            this.model.toggleSelection(itemId);
        },

        _addItem: function(item) {
            this.model.addItem(item);
        },

        _removeItem: function(itemId) {
            this.model.removeItem(itemId);
        },

        _select: function(itemId) {
            this.model.selectItem(itemId);
        },

        _unselect: function(itemId) {
            this.model.unselectItem(itemId);
        },

        _unselectAll: function() {
            this.model.unselectAll();
        },

        _filter: function(filterValue, page) {
            var forceFilter = (page && page !== this.model.getPage());
            if (page) {
                this.model.setPage(page);
            }

            filterValue = filterValue || "";
            this.model.setFilterValue(filterValue, forceFilter);
        },

        _getItems: function() {
            return this.model.getItems();
        },

        _getAllItems: function() {
            return this.model.getAllItems();
        },

        _setItems: function(items, options) {
            return this.model.setItems(items, options);
        },

        _getSelectedItems: function() {
            return this.model.getSelectedItems();
        },

        _getItemModel: function(itemId) {
            return this.model.getItemModel(itemId);
        },

        _onClose: function() {
            this.logger.info("Closing List", "List:_onClose");
        }

        //</editor-fold>

    });

    function _initListModel(options) {
        var model = new ListModel();

        if (_.has(options, "floating")) {
            model.setFloating(options.floating);
        }

        if (_.has(options, "groupCollapsible")) {
            model.setGroupCollapsible(options.groupCollapsible);
        }

        if (_.has(options, "maxShownItems")) {
            model.setMaxShownItems(options.maxShownItems);
        }

        if (_.has(options, "itemHeight")) {
            model.setItemHeight(options.itemHeight);
        }

        if (_.has(options, "itemsComparator")) {
            model.setItemsComparator(options.itemsComparator);
        }

        if (_.has(options, "groupsOrder")) {
            model.setGroupsOrder(options.groupsOrder);
        }

        if (_.has(options, "enabled")) {
            model.setEnabled(options.enabled);
        }

        if (_.has(options, "hasCheckbox")) {
            model.setHasCheckbox(options.hasCheckbox);
        }

        if (_.has(options, "noItems")) {
            model.setNoItemsModel(options.noItems);
        }

        if (_.has(options, "newItem")) {
            model.setNewItemModel(options.newItem);
        }

        if (_.has(options, "selectable")) {
            model.setSelectable(options.selectable);
        }

        if (_.has(options, "defaultActions")) {
            model.setDefaultActions(options.defaultActions);
        }

        if (_.has(options, "singleSelectPerGroup")) {
            model.setSingleSelectPerGroup(options.singleSelectPerGroup);
        }

        if (_.has(options, "paging")) {
            model.setPaging(options.paging);
        }

        if (_.has(options, "loadMoreOffset")) {
            model.setLoadMoreOffset(options.loadMoreOffset);
        }

        if (_.has(options, "pageSize")) {
            model.setPageSize(options.pageSize);
        }

        if (_.has(options, "items")) {
            model.setItems(options.items);
        }
        else {
            model.setItems([]);
        }

        if (_.has(options, "selectedItems")) {
            model.setSelectedItems(options.selectedItems);
        }

        if (_.has(options, "filterType")) {
            model.setFilterType(options.filterType);
        }

        return model;
    }

    List.NEW_ITEM_ID = ListModel.NEW_ITEM_ID;
    List.NO_ITEMS_ID = ListModel.NO_ITEMS_ID;
    List.TRIGGERING = TRIGGERING;
    List.THEME = THEME;
    List.FILTER_TYPES = ListModel.FILTER_TYPES;

    return List;
});
